module.exports = {"header_path_one":"Start with email & password","header_path_two":"Enter mobile number","header_path_three":"Confirm your details"}


//////////////////
// WEBPACK FOOTER
// ./src/locales/i18next/en/screens.json
// module id = 655
// module chunks = 247 1432